import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import type { ModalExtraOnlyPackSingleType } from "../../../utils/modalConstants";
import type { ExtraType, ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import { useBnbSelector } from "../../../redux/store";
import usePack from "../../../hooks/shared/packs/usePack";
import { BnbLabel } from "../../../utils/labels";
import Pack from "../step-customize/main-content/Pack";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonSecondary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";

// Modal used when an extra is only available in a pack and the extra is available in only one pack.
const ExtraOnlyPackSingleModal = (props: ModalViewType<ModalExtraOnlyPackSingleType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const { extra } = modalSettings;
    const items = useBnbSelector((state) => state.items);

    const pack = CarDataConsolidator.findPackEquipment(extra as ExtraType, items.packs)!.packs![0];
    const packProps = usePack(pack);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title smallText>
                    <BnbLabel label="extraOnlyPackSingleModalTitle" />
                </Modal.Title>
                <Modal.Button type="button" onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Pack pack={pack} showImage packIndex={0} isSinglePack />
            </Modal.Body>
            <Modal.Actions hasBorderTop rightAlignment stickyBottom>
                <ButtonPrimary
                    onClick={() => {
                        packProps?.actions.selectPack();
                        close();
                    }}
                >
                    <BnbLabel label="extraOnlyPackSingleModalConfirmAddPack" />
                </ButtonPrimary>
                <ButtonSecondary onClick={close} linkWithoutIcon>
                    <BnbLabel label="extraOnlyPackSingleModalCancel" />
                </ButtonSecondary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default ExtraOnlyPackSingleModal;
